<!-- regular header -->
<div *ngIf="this.shouldShowRegularHeader()"
     [ngClass]="{
        'card-header w-100': true,
        'header-summary mb-2' : this.getType() === headerType.summary
     }"
     [class]="this.getStyleClass()"
     class="ly-sp-s-bottom">
  <span *ngIf="this.getTitle()" [ngClass]="{
        'bs-h2 th-text-main' : this.getType() !== headerType.grey,
        'bs-paragraph th-text-gray-paragraphs' : this.getType() === headerType.grey
    }"
        [id]="this.getId()+'_title'">{{this.getTitle()}}</span>
  <span *ngIf="this.getDescription()" class="ly-sp-xs-top bs-paragraph th-text-gray-paragraphs">{{this.getDescription()}}</span>
  <ng-container #target></ng-container>
</div>

<!--full header -->
<div *ngIf="this.shouldShowFullHeader()"
     [ngClass]="{
        'w-100 d-flex align-items-center full-header-container': true,
        'th-bg-main': this.isMediumOrPrimary(),
        'th-bg-white': this.isWhite(),
        'full-header-container': this.isMedium || this.isSmall,
        'full-header-container-sm': this.isExtraSmall,
        'full-screnn-full-header' : this.getIsFullScreen()
    }"
    [class]="this.getStyleClass()">

    <!-- logo -->
    <div *ngIf="this.shouldShowLogo()"
        class="th-bg-white flex-logo d-flex justify-content-center align-items-center">
        <object [data]="this.ssvmnLogoPath | safeUrl"
                type="image/svg+xml"
                [width]="this.iconWidth+'px'"
                [height]="this.iconHeight+'px'">
        </object>
    </div>

    <!-- title -->
    <div *ngIf="this.shouldShowTitle()"
         [ngClass]="{
            'header-title': !this.isWhiteAndExtraSmall(),
            'header-title-spacing': this.isWhiteAndExtraSmall()
         }">
        <span class="bs-h1"
              [ngClass]="{
                'th-text-white': !this.isWhite(),
                'th-text-main': this.isWhite()
              }">{{this.getTitle()}}</span>
    </div>

    <!-- exit -->
    <div class="d-flex align-items-center"
        [ngClass]="{
            'th-bg-main': this.isMediumOrPrimary(),
            'th-bg-white': this.isWhite(),
            'flex-content': this.isMedium,
            'flex-content-sm': this.isSmall,
            'flex-content-xsm': this.isExtraSmall
        }">
        <div class="th-text-white ms-auto d-flex align-items-center">
            <span *ngIf="this.shouldShowExitText()"
                  class="bs-paragraph"
                  [ngClass]="{
                    'th-text-main': this.isWhite()
                  }">¿Ya no desea continuar?</span>
            <div class="d-flex align-items-center exit-container" (click)="this.openDialog()">
                <span class="bs-paragraph exit-text"
                      [ngClass]="{
                        'th-text-secondary': !this.isWhite(),
                        'th-text-main': this.isWhite()
                      }">
                      Salir
                </span>
                <img [src]="this.getExitIconPath()" [width]="17" [height]="20">
            </div>
        </div>
    </div>
    <ng-container #dialogTarget></ng-container>
</div>
